import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-card-content',
  templateUrl: './card-content.component.html',
  styleUrls: ['./card-content.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class CardContentComponent {
  @Input() isLoading: boolean = false;
  @Input() skeletonStyles: any = {};
}
